// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__kXlYa","footerBtn":"Footer_footerBtn__uozKY","textBtn":"Footer_textBtn__SPcw2","nextBtn":"Footer_nextBtn__9Kq2A"};